export default "__VITE_ASSET__2b123754__"